module.exports = __webpack_public_path__ + "static/media/noun_Document_504765.b00e71f8.svg";